import React from 'react';

export default function SubTitle(props) {
	return <h2 className="text-base uppercase md:text-lg 2xl:text-xl text-tertiary">{props.children}</h2>;
}
